import { useState } from "react";

import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import NewComment from "./NewComment";
import Comment from "./Comment";
import useAuth from "../../hooks/useAuth";

import "./css/comment-main.css";

import dateSlicer from "../../functions/dateSlicer";

const CommentMain = ({ comments, commentForId, commentFor }) => {
    const { auth } = useAuth();
    const [updateableComments, setUpdateableComments] = useState(comments);

    return (
        <div className="comment-main">
            <Accordion
                style={{
                    boxShadow: "0 0 0 1px #1717171a" // var(--box-shadow)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <span className="cmt-main-title title s-title">
                        Comments ({updateableComments.length})
                    </span>
                </AccordionSummary>

                <AccordionDetails>
                    {auth.isLoggedIn &&
                        <NewComment
                            commentForId={commentForId}
                            commentFor={commentFor}
                            setUpdateableComments={setUpdateableComments}
                        />
                    }

                    {updateableComments.map((item, key) => {
                        return (
                            <Comment
                                key={key}
                                serialNumber={key}
                                commentFor={commentFor}
                                commentForId={commentForId}
                                commentId={item._id}
                                commentById={item.commentById}
                                commentBy={item.commentBy}
                                commentByRole={item.commentByRole}
                                commentedOn={dateSlicer(item.commentedOn)}
                                updatedOn={dateSlicer(item.updatedOn)}
                                commentBody={item.commentBody}
                                updateableComments={updateableComments}
                                setUpdateableComments={setUpdateableComments}
                            />
                        );
                    })}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default CommentMain;